import * as React from 'react';
import { styled } from '../../theme';
import { PropsWithChildren } from 'react';

export interface ParagraphWidgetProps {
  className?: any;
}

export const ParagraphWidget: React.FC<PropsWithChildren<ParagraphWidgetProps>> = (props) => {
  return <S.Container className={props.className}>{props.children}</S.Container>;
};

const BASE_LABEL = 'paragraph-widget';
namespace S {
  export const Container = styled.div`
    label: ${BASE_LABEL};
    font-size: 16px;
    line-height: 20px;
    color: ${(p) => p.theme.text.primary};
    text-align: center;

    a {
      color: ${(p) => p.theme.text.primary};
      text-decoration: none;
      font-weight: bold;
    }
  `;
}
